<template>
    <div class="account-warpper">
        <div class="bg-white ">
            <div class="flex align-center justify-end margin-bottom">
                <el-button type="primary" @click="addLabel(false)">添加标签</el-button>
            </div>
            <el-table
                v-loading="loading"
                :data="labelList"
                header-row-class-name="table-header"
                row-class-name="table-row"
                alig="center"
                border
                style="width: 100%">
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="社区名称" prop="xiangmu_name"></el-table-column>
                <el-table-column label="标签名称" prop="name"></el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button
                                size="small"
                                type="primary"
                                @click="addLabel(scope.row)"
                            >编辑
                            </el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="delLabel(scope.row.id)"
                            >删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

        </div>

        <add-label-dialog :dialog="addDialog" :item="cur_item" @cancelDialog="cancelDialog"></add-label-dialog>
    </div>
</template>

<script>
import {delJuminTag, juminTagList} from "@/api/weilao";
import AddLabelDialog from "@/views/pages/dialog/addLabelDialog";

export default {
    name: "labelList",
    data() {
        return {
            labelList: [],
            addDialog:false,
            cur_item:'',
            loading:false,
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "双暖为老 / 居民标签管理", false);
        this.getLabelList()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    components: {AddLabelDialog},
    methods: {
        //  添加标签
        addLabel(data) {
            this.cur_item = data
           this.addDialog = true
        },
        cancelDialog(data) {
            if (data)this.getLabelList()
            this.addDialog = false
        },
        //  删除标签
        delLabel(id) {
            this.$confirm('您确定要删除该标签吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureDel(id);
            });
        },
        async sureDel(id) {
            const res = await delJuminTag(id)
            if (res.status === 200) this.$message.success('操作成功')
            await this.getLabelList()
        },
        //  获取列表
        async getLabelList() {
            this.loading = true
            let _list = await juminTagList()
            this.loading = false
            this.labelList = _list.data
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">

</style>
